import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useProductStore } from '@elem/compPage/a-new-era-of-cool/ProductProvider';
import { IPageStatus } from '@elem/compPage/a-new-era-of-cool/config/IPageStatus';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { useRouter } from 'next/router';

import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const { locale } = useRouter();

    const { pageStatus } = useProductStore();

    const labelText = !needTermsCheckLocales.includes(locale as string) ? t('label') : pageStatus === IPageStatus.statusB ? '' : t('label');
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1744440396526/outdoor_kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1744440396262/outdoor_kv_h5.jpg',
        label: labelText,
        title: t('title'),
        desc: t('desc'),

        // 按钮
        lType: 'filled',
        lChildren: t('btn1'),
        lHref: '#subscription-products-section',
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
}
